import React from "react";
import { makeAutoObservable } from "mobx";

import { useToast } from "../components/toast/useToast";
import Binder from "../utils/binder";
import apiv2 from "../apiv2";
import { colors } from "../components/styleguide/colors";
import authStore from "./authStore";
import appointmentStore from "./AppointmentStore";
import { history } from "../utils/history";

const toastManager = useToast(); // Добавил для дальнейшей работы с сокетами

export const EVALUATION_COLOR_MAP = {
  green: colors.success0,
  yellow: "#FFDC00",
  red: colors.error0,
  null: "#808080"
};

export const EVALUATION_COLORS = {
  GREEN: "green",
  YELLOW: "yellow",
  RED: "red"
};

export const EVALUATION_SCORE = [
  {
    from: 85,
    to: 100,
    color: EVALUATION_COLOR_MAP.green
  },
  {
    from: 70,
    to: 84,
    color: EVALUATION_COLOR_MAP.yellow
  },
  {
    from: 0,
    to: 69,
    color: EVALUATION_COLOR_MAP.red
  }
];

class AppointmentEvaluationStore {
  isEvaluationsLoading = false;
  aiEvaluation = null;
  isHideAiEvaluation = false;
  selectedExpert1 = null;
  selectedExpert2 = null;
  expertEvaluations = [];
  expandedSections = [];
  criterions = [];

  appointment = null;

  currentCriterionIndex = null;
  currentUserEvaluation = null;
  isEditMode = false;
  evaluationData = null;
  choicedCriteria = null;
  isEndEvaluateLoading = false;
  isOpenModal = false;
  isValidForm = false;
  isValidReasonForm = false;
  prevEvaluateAppointmentIds = [];
  expandedReasons = [];

  constructor() {
    Binder.bind(this, AppointmentEvaluationStore);
    makeAutoObservable(this, {}, { deep: true });
  }

  startEvaluation() {
    if (this.checkEvaluationFromLocalstorage()) {
      this.setIsEditMode(true);
    }
    return true;
  }

  setEvaluationsLoading(value) {
    this.isEvaluationsLoading = value;
  }

  setIsEndEvaluateLoading(value) {
    this.isEndEvaluateLoading = value;
  }

  onOpenModal() {
    this.isOpenModal = true;

    this.expandedReasons = this.choicedCriteria?.selected_reasons
      .filter(reason => reason.checked)
      .map(reason => reason.reason_id);

    this.expandedSections = this.evaluationData.criterion_values
      .filter(criteria => criteria?.color && criteria?.color !== "green")
      .map(criteria => criteria.criterion_id);
  }

  onEditCriteria(criterionIndex) {
    this.setCurrentCriterionIndex(criterionIndex);

    this.choicedCriteria = { ...this.evaluationData.criterion_values[criterionIndex] };
    this.choicedCriteria.selected_reasons =
      this.choicedCriteria?.selected_reasons.slice().map(criterion_reason => ({
        ...criterion_reason
      })) || null;

    this.onOpenModal();
  }

  onCloseModal() {
    this.isOpenModal = false;

    this.setIsValidForm();
  }

  setIsEndEvaluateLoading(value) {
    this.isEndEvaluateLoading = value;
  }

  onOpenModal() {
    this.isOpenModal = true;

    this.expandedReasons = this.choicedCriteria?.selected_reasons
      .filter(reason => reason.checked)
      .map(reason => reason.reason_id);

    this.setIsValidReasonForm();
  }

  onCloseModal() {
    this.isOpenModal = false;

    this.setIsValidForm();
  }

  setCurrentCriterionIndex(value) {
    this.currentCriterionIndex = value;
  }

  onSaveDataModal(criterionIndex) {
    this.evaluationData.criterion_values[criterionIndex] = {
      ...this.choicedCriteria,
      selected_reasons:
        this.choicedCriteria.selected_reasons?.slice().map(criterion_reason => ({
          ...criterion_reason
        })) || null
    };

    this.expandedSections.push(this.choicedCriteria.criterion_id);

    this.choicedCriteria === null;

    this.onCloseModal();
  }

  setExpandedSection(id, forcedClose) {
    if (this.isSectionExpanded(id) || forcedClose) {
      this.expandedSections = this.expandedSections.filter(sectionId => sectionId !== id);
    } else {
      this.expandedSections.push(id);
    }
  }

  setExpandedSections(value) {
    this.expandedSections = value;
  }

  setExpandedReasons(id, reason) {
    if (this.isReasonExpanded(id)) {
      this.expandedReasons = this.expandedReasons.filter(sectionId => sectionId !== id);

      reason.checked = false;
    } else {
      this.expandedReasons.push(id);
      reason.checked = true;
    }

    this.setIsValidReasonForm();
  }

  isSectionExpanded(id) {
    return this.expandedSections.includes(id);
  }

  isReasonExpanded(id) {
    return this.expandedReasons.includes(id);
  }

  setSelectedExpert(id, target) {
    const expert =
      target === "expert2" && id === this.aiEvaluation?.id
        ? this.aiEvaluation
        : this.expertEvaluations.find(e => e.id === id) ?? null;

    if (target === "expert1") {
      this.selectedExpert1 = expert;
    } else {
      this.selectedExpert2 = expert;
    }
  }

  setCurrentUserEvaluation() {
    const evaluation = this.expertEvaluations.find(
      evaluation => evaluation?.expert?.id === authStore?.user?.expert?.id
    );

    this.currentUserEvaluation = evaluation;
  }

  setIsEditMode(value) {
    this.isEditMode = value;
  }

  setIsDefected(value) {
    this.evaluationData.is_defected = value;

    if (value === false) {
      this.setDefectedComment("");
    }

    this.setIsValidForm();
  }

  setDefectedComment(value) {
    this.evaluationData.defect_comment = value;

    this.setIsValidForm();
  }

  setOverallComment(value) {
    this.evaluationData.overall_comment = value;

    this.setIsValidForm();
  }

  setCriterions(value) {
    this.criterions = value;
  }

  setStarColor(color, criterionIndex, criterionId) {
    if (this.evaluationData.criterion_values[criterionIndex].color !== color) {
      this.setCurrentCriterionIndex(criterionIndex);

      if (color === "red" || color === "yellow") {
        this.choicedCriteria = { ...this.evaluationData.criterion_values[criterionIndex] };
        this.choicedCriteria.selected_reasons =
          this.choicedCriteria[color].slice().map(criterion_reason => ({
            ...criterion_reason
          })) || null;

        this.onOpenModal();
      }

      if (color === "green") {
        this.choicedCriteria = this.evaluationData.criterion_values[criterionIndex];
        this.choicedCriteria.selected_reasons = [];

        this.setExpandedSection(this.choicedCriteria.criterion_id, true);
      }

      this.choicedCriteria.color = color;
    } else {
      this.evaluationData.criterion_values[criterionIndex].color = "";
    }

    this.setIsValidForm();
  }

  setCriterionComment(comment, criterion) {
    criterion.comment = comment;

    this.setIsValidReasonForm();
  }

  setIsValidForm() {
    const isDefected = this.evaluationData.is_defected && this.evaluationData.defect_comment.trim();

    if (isDefected) {
      this.isValidForm = true;
      return;
    }

    const isCriteriaValid = this.evaluationData.criterion_values.every(
      criterion =>
        criterion?.color === EVALUATION_COLORS.GREEN ||
        ((criterion?.color === EVALUATION_COLORS.RED ||
          criterion?.color === EVALUATION_COLORS.YELLOW) &&
          (criterion?.selected_reasons.some(reason => reason.checked) || criterion?.comment.trim()))
    );

    this.isValidForm = isCriteriaValid && !this.evaluationData.is_defected;
  }

  setIsValidReasonForm() {
    this.isValidReasonForm =
      this.choicedCriteria.selected_reasons.some(reason => reason.checked) ||
      this.choicedCriteria.comment.trim();
  }

  hideNotCurrentEvaluations() {
    this.setCurrentUserEvaluation();

    this.isHideAiEvaluation = true;
    this.aiEvaluation = null;
    this.selectedExpert1 = this.currentUserEvaluation;
    this.selectedExpert2 = null;
  }

  // Обогощение формы оценки, если начала или редактирования оценки
  setEvaluationData(criterions, expert) {
    const data = localStorage.getItem("evaluation");

    if (data) {
      this.evaluationData = JSON.parse(data);

      return;
    }

    this.evaluationData = {
      overall_comment: expert ? expert.overall_comment : "",
      is_created_by_ai: false,
      appointment_id: appointmentStore.appointment?.id,
      criterion_values:
        criterions?.map((item, index) => ({
          criterion_id: item.criterion?.id,
          color: expert ? expert?.criterion_values?.[index]?.color : "",
          comment: expert ? expert?.criterion_values?.[index]?.comment : "",
          selected_reasons: expert
            ? item?.criterion_reasons
                ?.filter(criterion_reason =>
                  criterion_reason?.selectable_colors.includes(
                    expert?.criterion_values?.[index]?.color
                  )
                )
                .map(criterion_reason => {
                  const selected = expert?.criterion_values?.[index]?.selected_reasons.find(
                    r => r.reason.id === criterion_reason?.reason.id
                  );
                  return {
                    reason_id: criterion_reason?.reason.id ?? "",
                    comment: selected?.comment ?? "",
                    name: criterion_reason?.reason.name ?? "",
                    checked: !!selected
                  };
                })
            : [],
          red:
            item?.criterion_reasons
              ?.filter(criterion_reason => criterion_reason?.selectable_colors.includes("red"))
              .map(criterion_reason => ({
                reason_id: criterion_reason?.reason.id ?? "",
                comment: "",
                name: criterion_reason?.reason.name ?? "",
                checked: false
              })) || null,
          yellow:
            item?.criterion_reasons
              ?.filter(criterion_reason => criterion_reason?.selectable_colors.includes("yellow"))
              .map(criterion_reason => ({
                reason_id: criterion_reason?.reason.id ?? "",
                comment: "",
                name: criterion_reason?.reason.name ?? "",
                checked: false
              })) || null
        })) || null,
      is_defected: expert ? expert.is_defected : false,
      defect_comment: expert ? expert.defect_comment : ""
    };
  }

  prepareEvaluationDataForSend() {
    return {
      ...this.evaluationData,
      criterion_values: this.evaluationData?.criterion_values.map(item => ({
        criterion_id: item?.criterion_id,
        color: item?.color ?? "",
        comment: item?.comment ?? "",
        selected_reasons: item?.selected_reasons
          ?.filter(reason => reason.checked)
          .map(reason => ({
            reason_id: reason?.reason_id ?? "",
            comment: reason?.comment ?? ""
          }))
      }))
    };
  }

  clearStores() {
    this.expertEvaluations = [];
    this.expandedSections = [];
    this.expandedReasons = [];
    this.expertEvaluations = [];
    this.criterions = [];
    this.evaluationData = null;
    this.choicedCriteria = null;
    this.currentUserEvaluation = null;
    this.currentCriterionIndex = null;
  }

  saveEvaluationToLocalstorage() {
    if (this.isEditMode) {
      const data = JSON.stringify(this.evaluationData);
      localStorage.setItem("evaluation", data);
      localStorage.setItem("appointment_evaluation_id", this.evaluationData?.appointment_id);
    }
  }

  checkEvaluationFromLocalstorage() {
    return !!localStorage.getItem("evaluation");
  }

  cleanEvaluationFromLocalstorage() {
    localStorage.removeItem("evaluation");
    localStorage.removeItem("appointment_evaluation_id");
  }

  async getAiEvaluationById(id) {
    if (!this.isHideAiEvaluation) {
      this.aiEvaluation = await apiv2.appointmentEvaluation.getAiEvaluationById(id);
    }
  }

  async getEvaluationById(ids) {
    this.expertEvaluations[0] = await apiv2.appointmentEvaluation.getEvaluationById(ids[0].id);

    if (ids.length > 1) {
      this.expertEvaluations[1] = await apiv2.appointmentEvaluation.getEvaluationById(ids[1].id);
    }
  }

  async getCriterionsForEvaluate(appointment, isSetEvaluationData) {
    try {
      this.setEvaluationsLoading(true);

      if (appointment?.layout?.id) {
        const response = await apiv2.appointments.getLayoutsToEvaluate(appointment?.layout?.id);
        this.setCriterions(response?.results);
      }

      this.setEvaluationData(this.criterions, this.currentUserEvaluation);

      if (localStorage.getItem("appointment_evaluation_id") == this.appointment.id) {
        const isEmptyTable =
          this.expertEvaluations.length === 0 && !this.aiEvaluation && !this.isEditMode;

        this.expandedSections = isEmptyTable
          ? []
          : this.evaluationData.criterion_values
              .filter(criteria => criteria?.color && criteria?.color !== "green")
              .map(criteria => criteria.criterion_id);
      }
    } catch (err) {
      throw Error("Ошибка в получении критериев");
    } finally {
      this.setEvaluationsLoading(false);
    }
  }

  async updateEvaluationsByAppointment(appointment, forced) {
    if (this.appointment?.id !== appointment?.id || forced) {
      try {
        this.appointment = appointment;

        this.setEvaluationsLoading(true);
        this.expertEvaluations = [];

        if (appointment.ai_evaluation?.id) {
          await this.getAiEvaluationById(appointment.ai_evaluation.id);
        }

        if (appointment.expert_evaluations && appointment.expert_evaluations.length > 0) {
          await this.getEvaluationById(appointment.expert_evaluations);
        }

        if (appointment?.my_expert_evaluation?.id) {
          this.expertEvaluations[0] = await apiv2.appointmentEvaluation.getEvaluationById(
            appointment?.my_expert_evaluation?.id
          );
        }

        this.setCurrentUserEvaluation();

        await this.getCriterionsForEvaluate(appointment, false);

        this.setSelectedExpert(this.expertEvaluations[0]?.id || null, "expert1");
        this.setSelectedExpert(
          this.aiEvaluation?.id || this.expertEvaluations[1]?.id || null,
          "expert2"
        );

        this.setExpandedSections([...this.expandedSections, "overall-comment", "defect_comment"]);
      } catch (err) {
        throw Error("Ошибка в получении оценок");
      } finally {
        this.setEvaluationsLoading(false);
      }
    }
  }

  async getNextToEvaluate(id) {
    this.setEvaluationsLoading(true);

    this.clearStores();
    this.cleanEvaluationFromLocalstorage();

    if (this.appointment?.id) {
      this.prevEvaluateAppointmentIds.push(this.appointment.id);
    }

    this.appointment = await appointmentStore.getAppointmentsNextToEvaluate();
    await this.updateEvaluationsByAppointment(this.appointment, true);

    this.setEvaluationsLoading(false);
  }

  async getPrevToEvaluate() {
    if (this.prevEvaluateAppointmentIds.length > 0) {
      this.clearStores();
      this.cleanEvaluationFromLocalstorage();

      const id = this.prevEvaluateAppointmentIds.pop();

      this.appointment = await appointmentStore.getAppointmentById(id);

      await this.updateEvaluationsByAppointment(this.appointment, true);
    }
  }

  async sendEvaluation(id) {
    try {
      this.setIsEndEvaluateLoading(true);
      this.cleanEvaluationFromLocalstorage();

      const prepareData = this.prepareEvaluationDataForSend();

      if (id) {
        const response = await apiv2.appointments.putAppointmentEvaluation(id, prepareData);

        await appointmentStore.getAppointmentById(response.appointment_id);

        this.expertEvaluations[0] = await apiv2.appointmentEvaluation.getEvaluationById(
          response.id
        );

        this.selectedExpert1 = this.expertEvaluations[0];
      } else {
        const response = await apiv2.appointments.postAppointmentEvaluation(prepareData);

        await appointmentStore.getAppointmentById(response.appointment_id);

        this.expertEvaluations[0] = await apiv2.appointmentEvaluation.getEvaluationById(
          response.id
        );

        this.selectedExpert1 = this.expertEvaluations[0];
      }
    } catch (err) {
      throw Error("Ошибка в создании оценки");
    } finally {
      this.setIsEditMode(false);
      this.setIsEndEvaluateLoading(false);
    }
  }

  getEvaluationColor(color) {
    return EVALUATION_COLOR_MAP[color];
  }
}

export default new AppointmentEvaluationStore();
